import { Money } from "../../common/models/CommonModels";

export interface ServiceReport {
  machineNumber: string;
  number: string;
  title: string;
  affectedPartCategoryId: string;
  description: string;
  notes?: string;
  alarmCode?: string;
  urgency?: number;
  statusCode: ServiceReportStatusCode;
  cost: Money;
  solvingDescription: string;
  openDate?: Date;
  closeDate?: Date;
  files: ServiceReportFile[];
}

export interface ServiceReportFile {
  name: string;
  content: string;
  size: number;
  typeCode: ServiceReportFileTypeCode;
}

export interface ChangeServiceReport {
  title: string;
  affectedPartCategoryId?: string;
  description: string;
  notes?: string;
  alarmCode?: string;
  urgency?: number;
  openDate?: Date;
  files: ServiceReportFile[] | null;
}

export interface ChangeSolvingServiceReport {
  cost?: Money;
  solvingDescription: string;
  closeDate?: Date;
  files: ServiceReportFile[] | null;
}

export interface CategoryReference {
  id: string;
  name: string;
}

// Machine Parts (from Machinery API /v1/machine-parts)
export interface MachinePartItem {
  id: string;
  name: string;
  groupKey: string;
  code: string;
  sortOrder: number;
}

export interface MachinePartGroup {
  groupKey: string;
  parts: MachinePartItem[];
}

export interface ServiceReportsQuery {
  statusCodes: ServiceReportStatusCode[];
}

export enum ServiceReportStatusCode {
  inProgress = 1,
  solved = 2
}

export enum ServiceReportFileTypeCode {
  reportDocument = 1,
  solvingReportDocument = 2
}

class ServiceReportCodes {
  private readonly map = {} as any;

  constructor() {
    this.map[ServiceReportStatusCode.inProgress] = "In Progress";
    this.map[ServiceReportStatusCode.solved] = "Solved";
  }

  serviceReportCode = (code: ServiceReportStatusCode) => {
    return this.map[code] || '';
  };
}

export const { serviceReportCode } = new ServiceReportCodes();